import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { BusinessVehicleMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-vehicle-metadata/business-vehicle-metadata.component.abstract';
import { VehicleMetadataV2Component } from '../../vehicle-metadata-v2/vehicle-metadata-v2.component';
import { SharedBusinessMetadataV2Component } from '../shared-business-metadata-v2/shared-business-metadata-v2.component';

@Component({
  selector: 'app-business-vehicle-metadata-v2',
  standalone: true,
  imports: [
    CommonModule,
    SharedBusinessMetadataV2Component,
    VehicleMetadataV2Component,
  ],
  template: `
    <app-shared-business-metadata-v2
      [baseMetadata]="metadata"
      [originalLead]="originalLead"
    />
    <app-vehicle-metadata-v2
      [baseMetadata]="metadata"
      [originalLead]="originalLead"
    />
  `,
})
export class BusinessVehicleMetadataV2Component extends BusinessVehicleMetadataComponentAbstract {}
